import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Icon from 'components/priority/Icon/Icon'
import EditorTextBoxModalShell from './EditorTextBoxModalShell'
import * as S from './EditorTextBoxModal.styled'

type MakeEditableModalProps = {
  onCancel: () => void
  onConfirm: () => void
}

export const MakeEditableModal: FC<MakeEditableModalProps> = ({
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation()

  return (
    <EditorTextBoxModalShell
      backdropTestId="data-editor-text-make-editable-backdrop"
      onDismiss={onCancel}
    >
      <S.Dialog
        $width="600px"
        data-editor-text-make-editable-modal
        role="dialog"
        aria-label={t('itemControls.makeEditable')}
      >
        <S.Header>
          <S.Title>{`${t('editor.pageItems.pageText.warning')}:`}</S.Title>
          <S.CloseBtn
            type="button"
            data-editor-text-make-editable-close
            title={t('editor.unsavedProgressModal.cancelButton')}
            onClick={onCancel}
          >
            <Icon icon="exitModal" width="16px" height="16px" />
          </S.CloseBtn>
        </S.Header>
        <S.Section>
          <S.Prose>{t('editor.pageItems.pageText.warningText')}</S.Prose>
        </S.Section>
        <S.Footer>
          <S.FooterSpacer />
          <S.GhostBtn
            type="button"
            data-editor-text-make-editable-cancel
            onClick={onCancel}
          >
            {t('editor.unsavedProgressModal.cancelButton')}
          </S.GhostBtn>
          <S.PrimaryBtn
            type="button"
            data-editor-text-make-editable-confirm
            onClick={onConfirm}
          >
            {t('editor.pageItems.pageText.confirm')}
          </S.PrimaryBtn>
        </S.Footer>
      </S.Dialog>
    </EditorTextBoxModalShell>
  )
}

export default MakeEditableModal
